import { render, staticRenderFns } from "./detail-things-like.vue?vue&type=template&id=56e849e5&scoped=true&"
import script from "./detail-things-like.vue?vue&type=script&lang=js&"
export * from "./detail-things-like.vue?vue&type=script&lang=js&"
import style0 from "./detail-things-like.vue?vue&type=style&index=0&id=56e849e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e849e5",
  null
  
)

export default component.exports